import { default as BodyEmpty } from './BodyEmpty';
import { default as Alert } from './Alert';

const EXPORT = { BodyEmpty, Alert };

export default EXPORT;
